import { sessionTypes } from '../constants'

export const isSessionPackage = context => {
  return context.online_service.sessionInfo.sessionType === sessionTypes.PACKAGE
}
